/**
 * Every brief cache key starts with `"brief"`, so the realtime hooks can flush
 * the whole family with one prefix filter. Only the mounted project's entries
 * are active, so the flush never wakes a backgrounded building.
 */
export const briefKeys = {
  all: ["brief"] as const,
  /** The schema probe — one per session, never per project. */
  schema: ["brief", "schema"] as const,
  /** Prefix families, for invalidating every project's entry of one kind. */
  findingsAll: ["brief", "findings"] as const,
  checksAll: ["brief", "checks"] as const,
  unconfirmedAll: ["brief", "unconfirmed"] as const,
  openCountAll: ["brief", "open-count"] as const,
  /** Every issue's "created from a brief appendix" lookup. */
  originAll: ["brief", "issue-origin"] as const,
  root: (projectId: number | null) => ["brief", "root", projectId] as const,
  documents: (briefId: number | null) => ["brief", "documents", briefId] as const,
  versions: (briefId: number | null) => ["brief", "versions", briefId] as const,
  versionDeletions: (briefId: number | null) => ["brief", "version-deletions", briefId] as const,
  appendices: (briefId: number | null) => ["brief", "appendices", briefId] as const,
  findings: (briefId: number | null) => ["brief", "findings", briefId] as const,
  checks: (briefId: number | null) => ["brief", "checks", briefId] as const,
  unconfirmed: (briefId: number | null) => ["brief", "unconfirmed", briefId] as const,
  openCount: (buildingId: number | null, projectId: number | null) =>
    ["brief", "open-count", buildingId, projectId] as const,
  origin: (issueId: number) => ["brief", "issue-origin", issueId] as const,
};
